import React, { useEffect, useState } from "react";
import { food, menu_section_left } from "../assets/images";
import CreateIcon from "@mui/icons-material/Create";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useNavigate } from "react-router-dom";
import {
  useCategoriesQuery,
  useDeleteItemMutation,
  useStatusChangeMutation,
} from "../constants/redux/api/api";
import ConfirmDeletePopup from "../components/ConfirmDeletePopup";

const MenuList = ({ menuOpen }) => {
  const navigate = useNavigate();
  const [allCategData, setAllCategData] = useState([]);
  const [categItems, setCategItems] = useState([]);
  const [deleteDetails, setDeleteDetails] = useState({});

  const [deletePopup, setDeletePopup] = useState(false);

  // RTK QUERY
  const { data: categoryData, isSuccess: isCategSuccess } =
    useCategoriesQuery();
  const [statusChange] = useStatusChangeMutation();
  const [deleteItem] = useDeleteItemMutation();

  useEffect(() => {
    if (isCategSuccess) {
      console.log(categoryData?.result);
      setAllCategData(categoryData?.result);
    }
  }, [categoryData, isCategSuccess]);

  useEffect(() => {
    if (allCategData?.length > 0) {
      let tmp = [];
      allCategData?.forEach((item) => {
        const categoryItemsTmp = item?.categoryItems?.map((el) => {
          return {
            ...el,
            categoryName: item?.categoryName,
            categoryNameId: item?.categoryNameId,
          };
        });
        tmp = [...tmp, ...categoryItemsTmp];
      });
      setCategItems([...tmp]);
    }
  }, [allCategData]);

  const onActiveClick = (item) => {
    console.log({
      categoryNameId: item?.categoryNameId,
      categoryItemsId: item?.id,
    });
    const formData = new FormData();
    formData.append("categoryNameId", item?.categoryNameId);
    formData.append("categoryItemsId", item?.id);
    statusChange({
      categoryNameId: item?.categoryNameId,
      categoryItemsId: item?.id,
    })
      .unwrap()
      .then((res) => {
        if (res?.status === "success") {
          console.log(res);
        }
      })
      .catch((err) => console.log(err));
  };

  const onClickDelete = (item) => {
    setDeletePopup(true);
    setDeleteDetails(item);
  };

  const confirmDeleteClick = () => {
    const item = {
      ...deleteDetails,
    };
    console.log({
      categoryid: item?.categoryNameId,
      categoryItemsid: item?.id,
    });
    // const formData = new FormData();
    // formData.append("categoryNameId", item?.categoryNameId);
    // formData.append("categoryItemsId", item?.id);
    deleteItem({
      categoryid: item?.categoryNameId,
      categoryItemsid: item?.id,
    })
      .unwrap()
      .then((res) => {
        if (res?.status === "success") {
          setDeletePopup(true);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div
      className={menuOpen ? "side-content2" : "side-content"}
      style={{
        transition: "0.5s",
      }}>
      <div className="menu-list">
        <h1>Menu List</h1>
      </div>
      <div className="side_pad">
        <div className="menu_section">
          <div className="ac-jb d-flex flex-md-wrap">
            <div className="px-2">
              <img src={menu_section_left} alt="decor" />
            </div>
            <div className="px-2 ">
              <h5>Check out your menu</h5>
              <p>You can add your menu from here</p>
            </div>
            <div className="d-flex gap-2">
              <button
                onClick={() => navigate("/add-category")}
                className="btn-outline">
                + Add Category
              </button>
              <button
                onClick={() => navigate("/add-menu")}
                className="btn-outline">
                + Add Menu
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* table start */}
      <div className="table-responsive menu-table side_pad">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Category</th>
              <th>Food Image</th>
              <th>Name</th>
              <th>Price</th>
              <th>Status</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody className="text-capitalize">
            {categItems?.map((item, ind) => {
              return (
                <tr>
                  <td>{ind + 1}</td>
                  <td>{item?.categoryName}</td>
                  <td>
                    <img
                      src={item?.url}
                      // src={food}
                      alt="food"
                    />
                  </td>
                  <td>{item?.food}</td>
                  <td>₹{item?.price}</td>
                  <td>
                    <button
                      onClick={() => onActiveClick(item)}
                      className={`${
                        item?.categoryItemsActivity == 1
                          ? "btn-success"
                          : "btn-danger"
                      } btn`}>
                      {item?.categoryItemsActivity == 1
                        ? "Active"
                        : "De-Active"}
                    </button>
                  </td>
                  <td className="text-center">
                    <div className="btn-group">
                      <td className="text-center">
                        <div className="btn-group">
                          <button
                            onClick={() =>
                              navigate("/add-menu", {
                                state: { type: "edit", data: item },
                              })
                            }
                            type="button"
                            className="btn btn-secondary">
                            <CreateIcon />
                          </button>
                          {/* <button
                            onClick={() => onClickDelete(item)}
                            type="button"
                            className="btn btn-secondary">
                            <CloseOutlinedIcon />
                          </button> */}
                        </div>
                      </td>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* table end */}
      {deletePopup && (
        <ConfirmDeletePopup
          onConfirmClick={confirmDeleteClick}
          onCancelClick={() => setDeletePopup(false)}
        />
      )}
    </div>
  );
};

export default MenuList;
